<template>
  <section class="theme-simple-section">
    <div class="container">
      <div class="section-header">
        <h2 class="title">테마별 추천 현장</h2>
        <p class="sub-title">내 상황에 딱 맞는 현장을 모아봤어요.</p>
      </div>

      <div class="theme-scroll-wrapper">
        <div class="theme-grid">

          <div
            v-for="(theme, index) in themes"
            :key="index"
            class="theme-card"
            @click="goToList(theme.id)"
          >
            <div class="icon-box" :class="theme.colorClass">
              <span class="emoji">{{ theme.emoji }}</span>
            </div>
            <h3 class="card-title">{{ theme.title }}</h3>
            <p class="card-desc">{{ theme.desc }}</p>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategorySection',
  data() {
    return {
      themes: [
        { id: 'money', title: '실투자 3천만', desc: '소액 갭투자', emoji: '💰', colorClass: 'green' },
        { id: 'brand', title: '1군 브랜드', desc: '힐스테이트/자이', emoji: '🏢', colorClass: 'red' },
        { id: 'subway', title: '초역세권', desc: '지하철 5분컷', emoji: '🚄', colorClass: 'blue' },
        { id: 'safe', title: '안심 보장제', desc: '원금 보장형', emoji: '🛡️', colorClass: 'purple' },
        { id: 'school', title: '명문 학세권', desc: '대치동급 학군', emoji: '🎓', colorClass: 'yellow' },
        { id: 'forest', title: '힐링 숲세권', desc: '공원 뷰 영구조망', emoji: '🌳', colorClass: 'teal' },
        { id: 'job', title: '직주근접', desc: '판교/강남 출근', emoji: '💼', colorClass: 'indigo' },
        { id: 'mall', title: '몰세권', desc: '스타필드 바로 앞', emoji: '🛍️', colorClass: 'pink' },
      ]
    }
  },
  methods: {
    goToList(themeId) {
      this.$router.push({ path: '/properties', query: { theme: themeId } })
    }
  }
}
</script>

<style scoped>
.theme-simple-section {
  padding: 20px 0 80px;
  background-color: #ffffff;
}

.container {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  margin-bottom: 40px;
}

.title {
  font-size: 32px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: -0.03em;
  margin-bottom: 8px;
}

.sub-title {
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
}

/* Scroll Wrapper */
.theme-scroll-wrapper {
  width: 100%;
}

.theme-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* Card Design */
.theme-card {
  background: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  height: 190px;
  position: relative;
  overflow: hidden;
}

.theme-card:hover {
  box-shadow: 0 20px 40px -4px rgba(0, 0, 0, 0.1);
  border-color: transparent;
  transform: translateY(-8px);
}

/* Icons Container */
.icon-box {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  font-size: 36px;
  transition: transform 0.3s ease;
}

.theme-card:hover .icon-box {
  transform: scale(1.1) rotate(5deg);
}

/* Color Themes */
.green { background: #ECFDF5; }
.red { background: #FEF2F2; }
.blue { background: #EFF6FF; }
.purple { background: #F5F3FF; }
.yellow { background: #FFFBEB; }
.teal { background: #F0FDFA; }
.indigo { background: #EEF2FF; }
.pink { background: #FDF2F8; }

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.card-desc {
  font-size: 14px;
  color: #6B7280;
  word-break: keep-all;
}

/* Responsive (Mobile) */
@media (max-width: 768px) {
  .theme-simple-section {
    padding: 50px 0;
  }

  .title { font-size: 32px; }

  .theme-scroll-wrapper {
    overflow-x: auto;
    padding-bottom: 24px;
    margin: 0 -24px;
    padding: 0 24px 24px 24px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .theme-scroll-wrapper::-webkit-scrollbar { display: none; }

  .theme-grid {
    display: flex;
    gap: 12px;
    width: max-content;
  }

  .theme-card {
    width: 140px;
    height: 170px;
    padding: 16px;
    flex: none;
    border-radius: 20px;
  }

  .icon-box {
    width: 60px;
    height: 60px;
    font-size: 30px;
    margin-bottom: 12px;
  }

  .card-title { font-size: 16px; }
  .card-desc { font-size: 13px; }
}
</style>
